<template>
  <router-link to="/settings">
<div class="warning"  v-if="showWarnings">
  <div class=" warning-scroll">
      <div class="warning-row">
        <div>
          <i class="fa-solid fa-circle-exclamation"></i>
        </div>
        <p>You are yet to complete setting up your profile</p>
      </div>
	
			  <div class="btn"  >
        <span>complete setup </span>
		<i class="fa-solid fa-angle-right"></i>
	  </div>

</div>
</div>
</router-link>
<router-link  to="/invoice/settings" >  
<div class="warning" v-if="invoiceSettings && analytics.charts">
  <div class=" warning-scroll">
      <div class="warning-row">
        <div>
          <i class="fa-solid fa-circle-exclamation"></i>
        </div>
        <p>You are yet to complete setting up your invoice settings</p>
      </div>
	  
			  <div class="btn"  >
        <span>complete setup </span>
		<i class="fa-solid fa-angle-right"></i>
	  </div>
  </div>
</div>
</router-link>
  <div class="row">
  
    <div class="col-xl-3 col-sm-6 col-12">
      <div class="card">
        <div class="card-body">
          <div class="dash-widget-header">
            <span v-if="currency === 'NGN'" class="dash-widget-icon bg-1">
              <i class="fas fa-naira-sign"></i>
            </span>
            <span v-else class="dash-widget-icon bg-1">
              <i class="fas fa-dollar-sign"></i>
            </span>
            <div class="dash-count">
              <div class="dash-title">Amount Due</div>
              <div class="dash-counts">
                <p>
                  {{
                    analytics?.amount_due
                      ? useCurrency(analytics?.amount_due)
                      : useCurrency(0)
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="progress progress-sm mt-3">
            <div
              class="progress-bar bg-5"
              role="progressbar"
              :style="`width: ${(analytics?.amount_due / 100) * 100}%`"
              :aria-valuenow="(analytics?.amount_due / 100) * 100"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-sm-6 col-12">
		<router-link  to="/invoices"    >   
			<div class="card">
        <div class="card-body">
          <div style="display: flex; justify-content: space-between; margin-bottom: -10px">
          <div class="dash-widget-header">
            <span class="dash-widget-icon bg-3">
              <i class="fas fa-file-alt"></i>
            </span>
            
            <div class="dash-count">
              <div class="dash-title">Invoices</div>
              <div class="dash-counts">
                <p>{{ analytics?.invoices }}</p>
              </div>
            </div>
          </div>
          <div>
            <router-link  to="/add-invoice" >
              <div  class="text-link-container">
            <p class="text-link">Create New Invoice</p>
            <i class="feather feather-arrow-right me-1"></i> 
          </div>
          </router-link>
          </div>
        </div>
          <div class="progress progress-sm mt-3">
            <div
              class="progress-bar bg-7"
              role="progressbar"
              :style="`width: ${(analytics?.invoices / 100) * 100}%`"
              :aria-valuenow="(analytics?.invoices / 100) * 100"
              aria-valuemin="0"
              aria-valuemax="10000"
            ></div>
          </div>
        </div>
      </div>
	</router-link>
    </div>

    
    <div class="col-xl-3 col-sm-6 col-12">
		<router-link
                to="/estimates"
              >
      <div class="card">
        <div class="card-body">
          <div style="display: flex; justify-content: space-between; margin-bottom: -10px">
          <div class="dash-widget-header">
            <span class="dash-widget-icon bg-4">
              <i class="far fa-file"></i>
            </span>
            <div class="dash-count">
              <div class="dash-title">Estimates</div>
              <div class="dash-counts">
                <p>{{ analytics?.estimates }}</p>
              </div>
            </div>
          </div>
          <div>
            <router-link  to="/add-estimate" >
              <div class="text-link-container">
            <p  class="text-link">Create New Estimate</p>
            <i class="feather feather-arrow-right me-1"></i> 
          </div>
          </router-link>
          </div>
          </div>
          <div class="progress progress-sm mt-3">
            <div
              class="progress-bar bg-8"
              role="progressbar"
              :style="`width: ${(analytics?.estimates / 100) * 100}%`"
              :aria-valuenow="(analytics?.estimates / 100) * 100"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </div>
	</router-link>
    </div>

    <div class="col-xl-3 col-sm-6 col-12">
		<router-link  to="/customers"    > 
      <div class="card">
        <div class="card-body">

          <div style="display: flex; justify-content: space-between; margin-bottom: -10px">
          <div class="dash-widget-header">
            <span class="dash-widget-icon bg-2">
              <i class="fas fa-users"></i>
            </span>
            <div class="dash-count">
              <div class="dash-title">Customers</div>
              <div class="dash-counts">
                <p>{{ analytics?.customers }}</p>
              </div>
            </div>
          </div>
        
          <div>
            <router-link  to="/add-customer" >
              <div class="text-link-container">
            <p class="text-link">Add New Customer</p>
            <i class="feather feather-arrow-right me-1"></i> 
          </div>
          </router-link>
          </div>
</div>
          <div class="progress progress-sm mt-3">
            <div
              class="progress-bar bg-6"
              role="progressbar"
              :style="`width: ${(analytics?.customers / 100) * 100}%`"
              :aria-valuenow="(analytics?.customers / 100) * 100"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </div>
	</router-link>
    </div>
   
  </div>

  <div class="row">
    <div class="col-xl-7 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="card-title">Sales Analytics</h5>

            <div class="dropdown">
              <button
                class="btn btn-white btn-sm dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {{ sales_filter }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li>
                  <a @click="changeSalesData('Weekly')" class="dropdown-item"
                    >Weekly</a
                  >
                </li>
                <li>
                  <a @click="changeSalesData('Monthly')" class="dropdown-item"
                    >Monthly</a
                  >
                </li>
                <li>
                  <a @click="changeSalesData('Yearly')" class="dropdown-item"
                    >Yearly</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap flex-md-nowrap"
          >
            <div
              class="w-100 d-flex align-items-center justify-content-between mb-3 flex-wrap flex-md-nowrap"
            >
              <div>
                <span>Total Sales</span>
                <p class="h5 text-primary me-3">
                  {{
                    sales_summary?.total
                      ? useCurrency(sales_summary?.total)
                      : useCurrency(0)
                  }}
                </p>
              </div>
              <div>
                <span>Paid</span>
                <p class="h5 text-success me-3">
                  {{
                    sales_summary?.paid
                      ? useCurrency(sales_summary?.paid)
                      : useCurrency(0)
                  }}
                </p>
              </div>
              <!-- <div>
                <span>Expenses</span>
                <p class="h4 text-danger me-3">
                  {{ useCurrency(sales_summary?.expenses) }}
                </p>
              </div> -->
              <div>
                <span>Earnings</span>
                <p class="h5 text-dark me-3">
                  {{
                    sales_summary?.profit
                      ? useCurrency(sales_summary?.profit)
                      : useCurrency(0)
                  }}
                </p>
              </div>
            </div>
          </div>

          <apexchart
            type="bar"
            height="350"
            :options="scolAreaChart.scol"
            :series="scolAreaChart.series"
            :key="sales_filter"
          ></apexchart>
        </div>
      </div>
    </div>
    <div class="col-xl-5 d-flex">
      <div class="card flex-fill">
        <div class="card-header">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="card-title">Invoice Analytics</h5>

            <div class="dropdown">
              <button
                class="btn btn-white btn-sm dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {{ invoice_filter }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li>
                  <a @click="changeInvoicesData('Weekly')" class="dropdown-item"
                    >Weekly</a
                  >
                </li>
                <li>
                  <a
                    @click="changeInvoicesData('Monthly')"
                    class="dropdown-item"
                    >Monthly</a
                  >
                </li>
                <li>
                  <a @click="changeInvoicesData('Yearly')" class="dropdown-item"
                    >Yearly</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="card-body apexchart-index">
          <apexchart
            type="donut"
            height="350"
            :options="donutAreaCharts.donutchart"
            :series="donutAreaCharts.series"
            :key="invoice_filter"
          ></apexchart>

          <div class="text-center text-muted">
            <div class="row">
              <div class="col-4">
                <div class="mt-4">
                  <p class="mb-2 text-truncate">
                    <i class="fas fa-circle text-primary me-1"></i> Invoiced
                  </p>
                  <h5>
                    {{
                      invoice_summary?.total
                        ? useCurrency(invoice_summary?.total)
                        : 0
                    }}
                  </h5>
                </div>
              </div>
              <div class="col-4">
                <div class="mt-4">
                  <p class="mb-2 text-truncate">
                    <i class="fas fa-circle text-success me-1"></i> Received
                  </p>
                  <h5>
                    {{
                      invoice_summary?.paid
                        ? useCurrency(invoice_summary?.paid)
                        : useCurrency(0)
                    }}
                  </h5>
                </div>
              </div>
              <div class="col-4">
                <div class="mt-4">
                  <p class="mb-2 text-truncate">
                    <i class="fas fa-circle text-warning me-1"></i> Pending
                  </p>
                  <h5>
                    {{
                      invoice_summary?.expenses
                        ? useCurrency(invoice_summary?.expenses)
                        : useCurrency(0)
                    }}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-6 col-sm-6">
      <div class="card">
        <div class="card-header">
          <div class="row align-center">
            <div class="col">
              <h5 class="card-title">Recent Invoices</h5>
            </div>
            <div class="col-auto">
              <router-link
                to="/invoices"
                class="btn-right btn btn-sm btn-outline-primary"
              >
                View All
              </router-link>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <div class="progress progress-md rounded-pill mb-3">
              <div
                class="progress-bar bg-success"
                role="progressbar"
                style="width: 25%"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
              <div
                class="progress-bar bg-warning"
                role="progressbar"
                style="width: 25%"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
              <div
                class="progress-bar bg-danger"
                role="progressbar"
                style="width: 25%"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
              <div
                class="progress-bar bg-info"
                role="progressbar"
                style="width: 25%"
                aria-valuenow="35"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <div class="row">
              <div class="col-auto">
                <i class="fas fa-circle text-success me-1"></i> Paid
              </div>
              <div class="col-auto">
                <i class="fas fa-circle text-warning me-1"></i> Draft
              </div>
              <div class="col-auto">
                <i class="fas fa-circle text-danger me-1"></i> Expired
              </div>
              <div class="col-auto">
                <i class="fas fa-circle text-info me-1"></i> Sent
              </div>
            </div>
          </div>

          <div class="table-responsive" style="min-height: 278px">
            <table class="table table-stripped table-hover">
              <thead class="thead-light">
                <tr>
                  <th>Invoice ID</th>
                  <th>Customer</th>
                  <th>Amount</th>
                  <th>Due Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody v-if="analytics?.recent?.invoices?.length > 0">
                <tr
                  v-for="invoice in analytics?.recent?.invoices"
                  :key="invoice.key"
                >
                  <td>
                    {{ invoice.invoice_id }}
                  </td>
                  <td>{{ invoice.customer?.name }}</td>
                  <td>
                    {{ invoice.currency }}
                    {{ addCurrencyComma(invoice.amount) }}
                  </td>
                  <td>{{ formatted(invoice.due_date) }}</td>
                  <td>
                    <span
                      class="badge text-capitalize"
                      :class="{
                        'bg-success-light text-success':
                          invoice.status === 'refunded' ||
                          invoice.status === 'viewed' ||
                          invoice.status === 'accepted' ||
                          invoice.status === 'paid',
                        'bg-info-light text-info': invoice.status === 'sent',
                        'bg-warning-light text-warning':
                          invoice.status === 'draft' ||
                          invoice.status === 'pending' ||
                          invoice.status === 'unpaid' ||
                          invoice.status === 'recurring' ||
                          invoice.status === 'partially_paid',
                        'bg-danger-light text-danger':
                          invoice.status === 'expired' ||
                          invoice.status === 'rejected' ||
                          invoice.status === 'overdue',
                      }"
                      >{{
                        invoice.status == "partially_paid"
                          ? "Partially paid"
                          : invoice.status
                      }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-if="analytics?.recent?.invoices?.length <= 0"
              class="align-center w-100 pt-4"
            >
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-sm-6">
      <div class="card">
        <div class="card-header">
          <div class="row align-center">
            <div class="col">
              <h5 class="card-title">Recent Estimates</h5>
            </div>
            <div class="col-auto">
              <router-link
                to="/estimates"
                class="btn-right btn btn-sm btn-outline-primary"
              >
                View All
              </router-link>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <div class="progress progress-md rounded-pill mb-3">
              <div
                class="progress-bar bg-success"
                role="progressbar"
                style="width: 25%"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
              <div
                class="progress-bar bg-warning"
                role="progressbar"
                style="width: 25%"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
              <div
                class="progress-bar bg-danger"
                role="progressbar"
                style="width: 25%"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
              <div
                class="progress-bar bg-info"
                role="progressbar"
                style="width: 25%"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <div class="row">
              <div class="col-auto">
                <i class="fas fa-circle text-success me-1"></i> Accepted
              </div>
              <div class="col-auto">
                <i class="fas fa-circle text-warning me-1"></i> Draft
              </div>
              <div class="col-auto">
                <i class="fas fa-circle text-danger me-1"></i> Expired
              </div>
              <div class="col-auto">
                <i class="fas fa-circle text-info me-1"></i> Sent
              </div>
            </div>
          </div>
          <div class="table-responsive" style="min-height: 278px">
            <table class="table table-hover">
              <thead class="thead-light">
                <tr>
                  <th>Estimate ID</th>
                  <th>Customer</th>
                  <th>Due Date</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody v-if="analytics?.recent?.estimates?.length > 0">
                <tr
                  v-for="estimate in analytics?.recent?.estimates"
                  :key="estimate.key"
                >
                  <td>
                    {{ estimate.estimate_id }}
                  </td>
                  <td>{{ estimate.customer?.name }}</td>
                  <td>{{ formatted(estimate.due_date) }}</td>
                  <td>
                    {{ estimate.currency }}
                    {{ addCurrencyComma(estimate.amount) }}
                  </td>
                  <td>
                    <span
                      class="badge text-capitalize"
                      :class="{
                        'bg-success-light text-success':
                          estimate.status === 'refunded' ||
                          estimate.status === 'viewed' ||
                          estimate.status === 'accepted' ||
                          estimate.status === 'paid',
                        'bg-info-light text-info': estimate.status === 'sent',
                        'bg-warning-light text-warning':
                          estimate.status === 'draft' ||
                          estimate.status === 'pending' ||
                          estimate.status === 'unpaid' ||
                          estimate.status === 'recurring' ||
                          estimate.status === 'partially_paid',
                        'bg-danger-light text-danger':
                          estimate.status === 'expired' ||
                          estimate.status === 'rejected' ||
                          estimate.status === 'overdue',
                      }"
                      >{{
                        estimate.status === "partially_paid"
                          ? "Partially paid"
                          : estimate.status
                      }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-if="analytics?.recent?.estimates?.length <= 0"
              class="align-center w-100 pt-4"
            >
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

   <!-- Add Charges -->
   <!-- <div class="modal custom-modal fade" id="addcharges_modal" role="dialog">
      <div class="modal-dialog modal-dialog-position modal-md">
        <div class="modal-content">
          <div class="modal-header modal-header-warning border-0 pb-0">
           <h3 style="margin-top: 20px;">Complete Account Setup</h3>
            <button
              type="button"
              class="close-btn"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <span  class="warning-modal-btn" aria-hidden="true">&times;</span>
            </button>
          </div>
          
        </div>
      </div>
    </div> -->
</template>
<script setup>
import {
  scolAreaChart,
  donutAreaCharts,
  getDataForBarChart,
  getDataForDonutChart,
} from "./data";
import { computed, onMounted, ref,watch } from "vue";
import { useStore } from "vuex";
import { formatted } from "@/assets/composables/date";
import { addCurrencyComma, useCurrency } from "@/assets/composables/currency";
// import { Modal } from "bootstrap";
const addWarningModal = ref(null);


const store = useStore();
const sales_filter = ref("");
const invoice_filter = ref("");
const sales_summary = ref(null);
const invoice_summary = ref(null);
const rerender = ref(0);
const currency = ref(null);
const user = ref(null)
const showWarnings = ref(false)
const invoiceSettings = ref(false)
const form = ref({
  name: "",
  address: "",
  postal_code: "",
  phone: "",
  country: null,
  state: null,
});

const isFormFilled = computed(() => {
  const { name, address, postal_code, phone, country, state } = form.value;
  return name && address && postal_code && phone && country !== null && state !== null;
});

watch(isFormFilled, (newValue) => {
  showWarnings.value = !newValue;
});

const invoiceForm = ref(
{
  invoice_prefix: "INV",
  estimate_prefix: "EST",
  service_category: null,
  preferred_due_date: null,
  business_logo: null,
}	
)

const settings = computed(() => {
  return store.getters["settings/settings"];
});
const getSettings = () => {
  store.dispatch("settings/getSettings").then(() => {
    invoiceForm.value = {
      invoice_prefix: settings.value.invoice_prefix,
      estimate_prefix: settings.value.estimate_prefix,
      service_category: settings.value.service_category,
      preferred_due_date: settings.value.preferred_due_date,
      business_logo: settings.value.business_logo,
    };
  });
  const invoiceFilled = computed(() => {
  const { invoice_prefix, estimate_prefix, service_category, preferred_due_date, business_logo } = invoiceForm.value;
  return invoice_prefix && estimate_prefix && service_category && preferred_due_date && business_logo !== null 
});

watch(invoiceFilled, (newValue) => {
	invoiceSettings.value = !newValue;
});
};




const analytics = computed(() => {
  return store.getters["settings/analytics"];
});
const getAnalytics = () => {
  store
    .dispatch("settings/getAnalytics")
    .then(() => {
      getDataForBarChart(analytics.value.charts?.this_week);
      getDataForDonutChart(analytics.value.charts?.this_week.summary);
      sales_summary.value = analytics.value.charts?.this_week.summary;
      invoice_summary.value = analytics.value.charts?.this_week.summary;
      currency.value = localStorage.getItem("currency");
    })
    .then(() => {
      sales_filter.value = "Weekly";
      invoice_filter.value = "Weekly";
    });
   
};

const changeSalesData = (filter) => {
  sales_filter.value = filter;
  if (filter === "Weekly") {
    getDataForBarChart(analytics.value.charts?.this_week);
    sales_summary.value = analytics.value.charts?.this_week.summary;
  } else if (filter === "Monthly") {
    getDataForBarChart(analytics.value.charts?.this_month);
    sales_summary.value = analytics.value.charts?.this_month.summary;
  } else {
    getDataForBarChart(analytics.value.charts?.this_year);
    sales_summary.value = analytics.value.charts?.this_year.summary;
  }
};
const changeInvoicesData = (filter) => {
  invoice_filter.value = filter;
  if (filter === "Weekly") {
    getDataForDonutChart(analytics.value.charts.this_week.summary);
    invoice_summary.value = analytics.value.charts.this_week.summary;
  } else if (filter === "Monthly") {
    getDataForDonutChart(analytics.value.charts.this_month.summary);
    invoice_summary.value = analytics.value.charts.this_month.summary;
  } else {
    getDataForDonutChart(analytics.value.charts.this_year.summary);
    invoice_summary.value = analytics.value.charts.this_year.summary;
  }
};

onMounted(() => {
  getAnalytics();
  getSettings();
  user.value = JSON.parse(localStorage.getItem("user"));
  form.value = {
    name: user.value.name,
    address: user.value.address,
    postal_code: user.value.postal_code,
    phone: user.value.phone,
    country: user.value.country,
    state: user.value.state,
  };

//   addWarningModal.value = new Modal(
//     document.getElementById("addcharges_modal"),
//     {
//       backdrop: "static",
//       keyboard: false,
//     }
//   );
});
</script>
<style scoped>

.card{

}
.text-link-container{
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid #1b2559;
  gap: 1px;
}
.text-link{
  font-size: smaller;
 
  font-weight: bold;
}

@media (max-width:960px) {
  .text-link{
  font-size: small;
}
.text-link-container{

  gap: 2px;
}
}
</style>